<template>
  <div style="margin-top: 70px">
    <div class="main_container main5">
      <div class="main">
        <div class="section-top">
          <div class="center">
            <h1><span></span>供应产品</h1>
            <p>智能陪护倡导者</p>
            <div
              style="
                width: 70px;
                border: 2px solid #ff3e3e;
                margin: 20px auto 20px auto;
              "
            ></div>
          </div>
        </div>
        <div style="clear: both"></div>
        <oem></oem>
      </div>
    </div>
    <el-carousel height="561px">
      <el-carousel-item v-for="item in images" :key="item.url">
        <img :src="item.url" alt="无图片" />
      </el-carousel-item>
    </el-carousel>
    <div class="rz_sm_main">
      <div class="icon_main">
        <div class="section-top">
          <div class="center">
            <h1><span>共享</span>解决方案</h1>
            <p>您的一站式共享解决方案提供商</p>
            <div
              style="
                width: 70px;
                border: 2px solid #ff3e3e;
                margin: 20px auto 20px auto;
              "
            ></div>
          </div>
        </div>
        <div style="clear: both"></div>
        <el-row style="width: 1200px; margin: 0 auto">
          <el-col :span="8" v-for="item in list" :key="item.title">
            <div class="bd">
              <ul class="picList_content">
                <li>
                  <div class="mc"></div>
                  <dl class="picList_content_one">
                    <!-- <dd>
                      <img style="width: 100%" :src="item.url" alt="无图片" />
                    </dd> -->
                    <el-image
                      :src="item.url"
                      style="width: 100%; height: 100%"
                      fit="scale-down"
                    >
                    </el-image>
                    <dt>
                      <span
                        style="
                          font-size: 22px;
                          color: #ff3e3e;
                          font-weight: bold;
                        "
                        >{{ item.title }}</span
                      >
                      <p
                        style="font-size: 14px; color: #666666; margin-top: 2px"
                      >
                        {{ item.description }}
                      </p>
                    </dt>
                  </dl>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="hyaline">
      <div class="hyaline_content">
        <div style="margin-bottom: 40px; text-align: center">
          <span style="font-size: 34px; color: #000">秒道</span
          ><span style="font-size: 34px; font-weight: 700; color: red"
            >平台打造</span
          >
        </div>
        <p class="hyaline_text">
          秒道控股集团有限公司是一家专业从事物联网智能设备( 秒道IOT盒子
          )研发、生产及支付系统于一体的高科技IOT( 物联网
          )平台企业,为时下火热的共享设备经济助力。公司已申请多项核心专利;将更多设备及产品通过秒道IOT(
          盒子 )接入物联网,为客户提供真正一秒到位的连接
        </p>
        <div class="hyaline_button">
          <div>
            <div class="hyaline_icon">
              <span id="num1">10</span>
            </div>
            <p>10余年开发经验</p>
          </div>
          <div>
            <div class="hyaline_icon">
              <span id="num2">30</span>
            </div>
            <p>30个行业解决方案</p>
          </div>
          <div>
            <div class="hyaline_icon">
              <span id="num3">200</span>
            </div>
            <p>200家平台打造</p>
          </div>
          <div>
            <div class="hyaline_icon">
              <span id="num4">500</span>
            </div>
            <p>500家行业客户选择</p>
          </div>
        </div>
      </div>
    </div>
    <div class="customer">
      <div class="customer_main">
        <div class="customer_content">
          <div style="margin-bottom: 40px; text-align: center">
            <span style="font-size: 34px; color: #000">秒道</span
            ><span style="font-size: 34px; font-weight: 700; color: red"
              >战略客户</span
            >
            <p style="font-size: 16px; color: #666">
              您的一站式共享解决方案提供商
            </p>
            <div
              style="
                width: 70px;
                border: 2px solid #ff3e3e;
                margin: 20px auto 70px auto;
              "
            ></div>
            <div style="width: 100%; height: 600px; margin: auto">
              <el-image
                style="
                  width: 100%;
                  height: 100%;
                  border: 1px solid #ccc;
                  margin-left: 10px;
                "
                :src="require('../assets/image/hezuo.png')"
              ></el-image>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="case">
      <div class="case_main">
        <div class="case_title">
          <span style="font-size: 34px; color: #000">秒道</span
          ><span style="font-size: 34px; font-weight: 700; color: red"
            >投放案例</span
          >
          <!-- <div class="case_butBox">
            <div class="case_but caseActive" onClick="case_but(0)">
              陪护体系
            </div>
            <div class="case_but" onClick="case_but(1)">按摩体系</div>
          </div> -->
        </div>
        <div class="case_contnet">
          <div>
            <img src="../assets/peihu/1.jpg" alt="" />
          </div>
          <div><img src="../assets/peihu/15.png" alt="" /></div>
          <div><img src="../assets/peihu/2.jpg" alt="" /></div>
          <div><img src="../assets/peihu/3.png" alt="" /></div>
          <div><img src="../assets/peihu/4.png" alt="" /></div>
          <div><img src="../assets/peihu/5.png" alt="" /></div>
          <div><img src="../assets/peihu/6.jpg" alt="" /></div>
          <div><img src="../assets/peihu/7.jpg" alt="" /></div>
          <div><img src="../assets/peihu/8.png" alt="" /></div>
          <div><img src="../assets/peihu/9.png" alt="" /></div>
          <div><img src="../assets/peihu/10.png" alt="" /></div>
          <div><img src="../assets/peihu/11.jpg" alt="" /></div>
          <div><img src="../assets/peihu/12.png" alt="" /></div>
          <div><img src="../assets/peihu/13.png" alt="" /></div>
          <div><img src="../assets/peihu/14.png" alt="" /></div>
        </div>
      </div>
    </div>

    <!--   <div class="main_container main5">
      <div class="main">
        <div class="section-top">
          <div class="center">
            <h1><span>新闻</span>资讯</h1>
            <p>了解秒道最新产品动态</p>
            <div
              style="
                width: 70px;
                border: 2px solid #ff3e3e;
                margin: 20px auto 20px auto;
              "
            ></div>
          </div>
        </div>
        <div style="clear: both"></div>
        <div class="IMg-left">
          <yang:artlist
            typeid="73"
            limit="1"
            titlelen="24"
            infolen="30"
            flag="b"
          >
            <a href="{$artlist.url}">
              <img src="{$artlist.litpic|get_picture}" />
              <div class="Img-zh">
                <p>{$artlist.title}</p>
                <li>{$artlist.description} ...</li>
              </div>
            </a>
          </yang:artlist>
        </div>

        <div class="active_t">
          <yang:artlist
            typeid="73"
            limit="4"
            titlelen="30"
            infolen="30"
            orderby="publishtime DESC"
          >
            <dl>
              <dd>
                <h1>{$artlist.updatetime|date="d",###}</h1>
                <span>{$artlist.updatetime|date="Y-m",###}</span>
              </dd>
              <dt>
                <p style="font-weight: normal">
                  <a href="{$artlist.url}">{$artlist.title}</a>
                </p>
                <span>{$artlist.description} ...</span>
              </dt>
            </dl>
          </yang:artlist>
        </div>
      </div>
    </div> -->
    <div class="banner4">
      <div class="banner">
        <h2>还在犹豫什么？</h2>
        <div>
          <a href="/wb/index.php/List/index?e=contact">立即加入</a>
        </div>
      </div>
    </div>

    <div id="footer">
      <div class="footer">
        <ul>
          <li>关于我们</li>
          <li style="width: 28px; height: 2px; background-color: #c95d5d"></li>
          <li>
            <a href="http://miaodaokeji.com/wb/index.php/List/index?e=contact"
              >公司简介</a
            >
          </li>
        </ul>
        <ul>
          <li>联系方式</li>
          <li class="phone-number" style="margin-left: 62px"></li>
          <li style="font-size: 24px; font-weight: bold">400-100-6186</li>
          <li>24小时咨询热线</li>
          <li>
            浙江省杭州市余杭区仓前街道文一西路1380号2楼207、208、209、210室
          </li>
        </ul>
      </div>
    </div>
    <div class="footer-div">
      Copyright © 秒道控股集团有限公司 版权所有 备案号：<a
        href="https://beian.miit.gov.cn"
        target="_blank"
        style="color: #0099ff"
        >浙ICP备2023007064号-2</a
      >
    </div>

    <!-- <div class="yb_conct">
        <div class="yb_bar">
            <ul>
                <li class="yb_top">返回顶部</li>
                <li class="yb_phone">400-100-6186</li>
                <li class="yb_QQ">
                    <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=289170251&site=qq&menu=yes">合作顾问</a>
                </li>
                </li>
                <li class="yb_ercode" style="height:53px;">秒道公众号<br>
                    <img class="hd_qr" src="__PUBLIC__/img/ewm.png" width="125"> </li>
            </ul>
        </div>
    </div> -->
  </div>
</template>
<script>
import Oem from './components/oem.vue';
export default {
  components: { Oem },
  data() {
    return {
      images: [
        { url: require('../assets/image/1.jpg') },
        { url: require('../assets/image/2.jpg') },
        { url: require('../assets/image/3.jpg') },
        { url: require('../assets/image/4.jpg') },
        { url: require('../assets/bo.png') },
      ],

      list: [
        {
          url: require('../assets/image/5.jpeg'),
          title: '共享陪护椅（加厚版）',
          description:
            '秒道共享陪护椅，专利核心产品，配装秒道智能锁，租借简单，美观耐用，提供软件平台支持',
        },
        {
          url: require('../assets/image/6.jpeg'),
          title: '共享陪护床',
          description:
            '秒道陪护床柜，多种款式规格，柜子配件均来自德国、日本等世界顶级配件商，提供软件平台支持',
        },
        {
          url: require('../assets/image/7.jpeg'),
          title: '共享陪护锁',
          description:
            '秒道智能锁，多项核心发明专利，广泛应用于医疗共享设备，目前已经成功对接设备15种                                    ',
        },
        {
          url: require('../assets/image/8.jpeg'),
          title: '共享陪护椅改造',
          description:
            '医疗陪护改造专利产品，传统陪护椅加装秒道智能锁，三分钟改造成功，现面向全国招募改造合伙人',
        },
        {
          url: require('../assets/image/9.jpeg'),
          title: '共享挂床',
          description:
            '秒道共享陪护挂床，专业陪护架，对接6张挂床，扫码租借，解决医院陪护难问题',
        },
        {
          url: require('../assets/image/10.jpeg'),
          title: '共享折叠床',
          description:
            '道共享折叠床，专业陪护架，对接3张折叠床，舒适大方，已广泛投放医院陪护场所',
        },
        {
          url: require('../assets/image/11.jpeg'),
          title: '共享轮椅',
          description:
            '秒道共享轮椅，专业陪护架，对接3张轮椅，租借简单，已广泛投放于医院场所    ',
        },
        {
          url: require('../assets/image/12.jpeg'),
          title: '集中式消毒陪护床',
          description:
            '集中式消毒陪护床，为抗疫助力而生的专利产品。智能消杀，安全卫生；占地小，适合对产地有限制的医院；运维简单，无需专人负责；家属使用方便，规范化。',
        },
        {
          url: require('../assets/image/13.jpeg'),
          title: '集中式消毒轮椅柜',
          description:
            '集中式消毒轮椅柜，冠状病毒消杀率99.99%。集中式投放，管理方便；智能化消毒，使用更方便；轮椅不仅舒适还更耐用。',
        },
      ],
    };
  },
};
</script>
<style>
/* .rz_sm_main {
  height: auto !important;
} */

.section-top {
  width: 100%;
  height: 90px;
  text-align: center;
  margin-top: 80px;
  float: left;
}
.section-top h1 {
  font-size: 34px;
  font-weight: 900;
  color: #ff3e3e;
}
.picList_content > li {
  width: 370px;
  height: 330px;
  margin: 22px 0;
  position: relative;
  cursor: pointer;
}
.picList_content_one dd {
  height: 220px;
}
.mc {
  width: 100%;
  height: 0%;
  background-color: rgba(0, 0, 0, 0.3);
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.5s;
}
.hyaline {
  margin-top: 50px;
  height: 680px;
  background-color: rgba(0, 0, 0, 0.1);
  padding: 70px 0 120px 0;
  box-sizing: border-box;
}

.hyaline_content {
  width: 1200px;
  margin: 0 auto;
}

.hyaline_text {
  font-size: 18px;
  color: #333333;
  text-align: center;
  line-height: 33px;
  letter-spacing: 1px;
}

.hyaline_icon {
  background-size: 100% 100%;
  width: 190px;
  height: 190px;
  line-height: 190px;
  margin-bottom: 10px;
  background-image: url('../assets/image/homeIcon.png');
}

.hyaline_button {
  margin-top: 145px;
  display: flex;
  justify-content: space-evenly;
  text-align: center;
}

.hyaline_button > div {
  display: flex;
  text-align: center;
  flex-wrap: wrap;
  justify-content: center;
}

.hyaline_button > div {
  width: 220px;
  height: 230px;
  color: white;
}

.hyaline_icon > span {
  font-size: 56px;
  font-weight: 700;
}

.hyaline_button > div > p {
  width: 100%;
  font-size: 20px;
}

.customer {
  width: 100%;
  height: 920px;
  background-color: white;
}

.customer_main {
  width: 1200px;
  height: 100%;
  box-sizing: border-box;
  margin: 0 auto;
  padding-top: 80px;
}
.case_contnet {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.case_contnet img {
  width: 100%;
  height: 100%;
}
.case_contnet > div {
  background-color: white;
  border-radius: 5px;
  width: 220px;
  height: 140px;
  margin-bottom: 20px;
}

.case {
  width: 100%;
  height: 680px;
  background-color: #cccccc;
}

.case_main {
  height: 680px;
  width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  padding-top: 60px;
}
.case_title {
  text-align: center;
}
.banner4 {
  height: 354px;
  background: url('../assets/image/banner2.jpg') no-repeat center;
}

.banner4 {
  height: 354px;
  position: relative;
  background-size: 100%;
}
.banner4 .banner {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  float: left;
  background-color: rgba(0, 0, 0, 0.5);
}
.banner4 .banner h2 {
  font-size: 32px;
  color: #ffffff;
  float: left;
  width: 100%;
  text-align: center;
  height: 200px;
  line-height: 250px;
  position: relative;
}
.banner4 .banner div {
  width: 375px;
  margin: 20px auto 0;
}
.banner4 .banner div a {
  width: 375px;
  height: 52px;
  float: left;
  text-decoration: none;
  background-color: #fe4141;
  border-radius: 5px;
  text-align: center;
  line-height: 52px;
  font-size: 20px;
  color: #ffffff;
  position: relative;
}

#footer {
  width: 100%;
  float: left;
  background-color: #263134;
}
#footer .footer {
  width: 1200px;
  margin: 0 auto;
}
#footer .footer ul {
  float: left;
  width: auto;
  margin-top: 45px;
  margin-left: 102px;
}
#footer .footer ul li {
  margin-bottom: 20px;
  color: #92979a;
}
#footer .footer ul li a {
  color: #92979a;
  font-size: 14px;
}
#footer .footer ul li:first-of-type {
  font-size: 16px;
  color: #ffffff;
  font-weight: bold;
  margin-bottom: 10px;
}
/* #footer .footer ul li:nth-of-type(2) {
  width: 28px;
  height: 2px;
  background-color: #c95d5d;
} */

.footer-div {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #000;
  color: #92979a;
  font-size: 14px;
}
.phone-number::before {
  content: '';
  display: block;
  width: 28px;
  height: 2px;
  background-color: #c95d5d;
  margin-left: 166px;
}
</style>
